/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-17 17:18:53
 * @LastEditors: yinj
 * @LastEditTime: 2021-02-22 18:16:07
 */
/* eslint-disable */
import Element from '../../components/core/models/element';
import Page from '../../components/core/models/page';
import Work from '../../components/core/models/work';
import { getOnePptWrap, saveScheme, exportPpt, exportPdf, pptWrapUpdate, getEffectPic, pptWrapSaveInfo,getPanoramaQrCode ,getSentenceCategoryList,getSentenceListWithChild} from '@/services/modules/scheme'
import { asyncData2workData } from '@/utils/work.js'
import Vue from 'vue';

// import work from '@/mock/work';
export const actions = {
  updateWork({ commit, state }, payload = {}) {
    // update work with strapi
    const work = {
      ...state.work,
      ...payload,
    };
    commit('setWork', work);
  },
  // 获取并更新work
  async getUpdateWork({state, commit}, payload) {
    const { success, result } = await getOnePptWrap(payload);
    const newRsult = success ? asyncData2workData(result) : null;
    const work = {
      ...state.work,
      ...newRsult,
    }
    commit('setWork', work);
  },
  // 获取标签列表
  async getWork({ state, commit }, payload) {
    const { success, result } = await getOnePptWrap(payload)
    const newRsult = success ? asyncData2workData(result) : null
    success && commit('setWork', newRsult)
    return newRsult
  },
  // 保存方案信息
  async saveScheme({ commit }, payload) { // eslint-disable-line
    const { success, result } = await saveScheme(payload);
    if (success && result) {
      return result;
    }
    return false;
  },
  // 导出ppt
  async exportPpt({ commit }, payload) { // eslint-disable-line
    const resp = await exportPpt(payload);
    return resp
  },
  // 导出pdf
  async exportPdf({ commit }, payload) { // eslint-disable-line
    const resp = await exportPdf(payload);
    return resp;
  },
  // 修改ppt
  async pptWrapUpdate({ commit, state }, payload) { // eslint-disable-line
    const workObj = {
      id: state.work.id
    }
    const resp = await pptWrapUpdate({ ...payload, ...workObj });
    return resp;
  },
  // 保存整个pptInfo数据落库
  async pptWrapSaveInfo({ commit, state }, payload) { // eslint-disable-line
    const resp = await pptWrapSaveInfo(payload);
    return resp;
  },
  // 效果图列表
  async getEffectPic({ commit, state }, payload) { // eslint-disable-line
    const { success, result } = await getEffectPic(payload);
    if (success) {
      return result;
    }
    return null;
  },
  // 全景二维码
  async getPanoramaQrCode({ commit, state }, payload) { // eslint-disable-line
    const { success, result } = await getPanoramaQrCode(payload);
    if (success) {
      return result;
    }
    return null;
  },
  // 获取文案类型
  async getSentenceCategoryList({ commit, state }, payload) { // eslint-disable-line
    const { success, result } = await getSentenceCategoryList(payload);
    if (success) {
      commit('setSentenceCategory',result)
      return result;
    }
    return null;
  },
  async getSentencListWithChild({ commit, state }, payload) { // eslint-disable-line
    const { success, result } = await getSentenceListWithChild(payload);
    if (success) {
      commit('setSentenceList',result)
      return result;
    }
    return null;
  },
};

// mutations
export const mutations = {
  setWork(state, work) {
    window.__work = work;
    work.pages = work.pages.map((page) => {
      page.elements = page.elements.map(element => new Element(element));
      return new Page(page);
    });
    state.work = new Work(work);
  },
  setSentenceCategory(state,val){
    state.sentenceCategory = val
  },
  setSentenceList(state,val){
    state.sentenceList = val
  }
};
